var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0081 9.63017L2.40625 12.0376L4.81366 11.4357L11.7867 4.46267C12.0124 4.23694 12.1391 3.93083 12.1391 3.61165C12.1391 3.29247 12.0124 2.98636 11.7867 2.76063L11.6832 2.65712C11.4575 2.43146 11.1514 2.30469 10.8322 2.30469C10.513 2.30469 10.2069 2.43146 9.98116 2.65712L3.0081 9.63017Z",
    stroke: "#011A3C",
    strokeWidth: 1.2037,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0081 9.6318L2.40625 12.0392L4.81366 11.4374L10.8322 5.41884L9.02662 3.61328L3.0081 9.6318Z",
    fill: "#011A3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02792 3.61328L10.8335 5.41884M7.82422 12.0392H12.639",
    stroke: "#011A3C",
    strokeWidth: 1.2037,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFill);
export default __webpack_public_path__ + "static/media/edit-fill.4de0ef7674c3e180cbb4d7ed63f8473d.svg";
export { ForwardRef as ReactComponent };